export const selectEntity = ({ fieldName, value, searchContext }) => {
  const properFieldName = fieldName.replace(/^\w/, (c) => c.toUpperCase());
  searchContext["set" + properFieldName + "Selected"](value);

  if (searchContext[fieldName + "Filtered"]) searchContext["set" + properFieldName + "Filtered"](value);
};
